<template>
  <v-app>
   <navibar></navibar>
    <v-main>
        <router-view />
    </v-main>
  </v-app>
</template>

<script>
import navibar from './components/Nav/NaviBar.vue'
export default {
  name: 'App',
  components: {navibar}
}
</script>

<style>
#app {
 font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue